<ng-container [formGroup]="form">
  <ion-content>
    <div class="order-setup">
      <div class="order-setup__form">
        <div class="order-setup__form__row custom-flex-col flex-gap-px-16">
          <label>Date</label>
          <ion-item class="border" lines="none">
            <ion-select class="w-full" formControlName="date" [disabled]="dates.length === 1">
              <ion-select-option *ngFor="let date of dates" [value]="date">
                {{date | date: 'fullDate'}}
              </ion-select-option>
            </ion-select>
          </ion-item>
        </div>
        <div class="order-setup__form__row">
          <label>Meal</label>
          <pos-meal-radio-group [disabled]="!!ticket"
                                [currentMeal]="currentMeal"
                                formControlName="mealId">
          </pos-meal-radio-group>
        </div>
        <div class="order-setup__form__row">
          <label>Order Type</label>
          <pos-order-type-radio-group formControlName="orderType"></pos-order-type-radio-group>
        </div>
        <div class="order-setup__form__row">
          <label>Time</label>
          <pos-time-picker
                           [ngClass]="{
                            'ion-margin-top': true,
                            disabled: !orderTypeValue
                            }"
                           [showAsapOption]="isCurrentDate"
                           formControlName="mealDeliveryAreaTiming"
                           [timings]="selectedTimings"
                           [deliveryType]="orderTypeValue">
          </pos-time-picker>
        </div>
      </div>
      <button [disabled]="!form.valid" (click)="onSubmit()">Save</button>
      <fa-icon [icon]="faTimes" (click)="onClose()"></fa-icon>
    </div>
  </ion-content>
</ng-container>
